import type {DependencyList} from 'react';
import {useEffect, useRef} from 'react';

type KeyboardEventHandler = (event: KeyboardEvent) => void;

export const useKeyboardEvent = (
	handler: KeyboardEventHandler,
	deps: DependencyList = [],
) => {
	const savedHandler = useRef<KeyboardEventHandler>(handler);

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		const listener = (event: KeyboardEvent) => {
			savedHandler.current(event);
		};

		document.addEventListener('keydown', listener);

		return () => {
			document.removeEventListener('keydown', listener);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
};
